import { apiFetch } from "./apiFetch";

export interface HostSchedule {
  monday?: string;
  tuesday?: string;
  wednesday?: string;
  thursday?: string;
  friday?: string;
  saturday?: string;
  sunday?: string;
  default: string;
}

export interface InstanceMetadata {
  meetingType?: string;
  memberVisible?: boolean;
  hostId?: string;
}

export interface RecurringMetadata {
  meetingType?: string;
  memberVisible?: boolean;
  hostSchedule?: HostSchedule;
}

export interface RecurringMeeting {
  id: string;
  recurrenceRule?: string[] | null;
  metadata: RecurringMetadata;
}

export interface Meeting {
  id: string;
  recurringMeetingId?: string | null;
  recurrenceRule?: string[] | null;
  title: string;
  start: string;
  end: string;
  description: string;
  meetingUrl: string;
  hostId?: string | null;
  metadata: InstanceMetadata;
  recurringMeeting?: RecurringMeeting | null;
}

export const MeetingResource = {
  getList: (params: { start: string; end: string }) =>
    apiFetch<Meeting[]>("/admin/meetings", { searchParams: params }),

  update: (
    id: string,
    data: {
      instanceMetadata?: Record<string, any>;
      recurringMetadata?: Record<string, any>;
    }
  ) =>
    apiFetch<{ result: string }>(`/admin/meeting/${id}`, {
      method: "PATCH",
      body: data,
    }),
};
